import React from 'react';
import Icon from '../../../components/AppIcon';

const PartnershipTimeline = ({ milestones }) => {
  return (
    <div className="bg-card rounded-lg p-4 md:p-6 lg:p-8 border border-border">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Clock" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground font-headline">
            Partnership Timeline
          </h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Key milestones and achievements
          </p>
        </div>
      </div>
      <div className="relative">
        <div className="absolute left-4 md:left-6 top-0 bottom-0 w-0.5 bg-border" />

        <div className="space-y-6 md:space-y-8">
          {milestones?.map((milestone, index) => (
            <div key={milestone?.id} className="relative pl-12 md:pl-16">
              <div className="absolute left-0 w-8 h-8 md:w-12 md:h-12 bg-primary rounded-full flex items-center justify-center shadow-lg">
                <Icon name={milestone?.icon} size={16} color="#FFFFFF" />
              </div>

              <div className="bg-muted rounded-lg p-4 md:p-5 hover:shadow-md transition-shadow duration-300">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-2 mb-3">
                  <h3 className="text-base md:text-lg font-semibold text-foreground font-headline">
                    {milestone?.title}
                  </h3>
                  <span className="text-xs md:text-sm text-muted-foreground whitespace-nowrap">
                    {milestone?.date}
                  </span>
                </div>
                <p className="text-sm md:text-base text-muted-foreground mb-3">
                  {milestone?.description}
                </p>
                {milestone?.metrics && (
                  <div className="flex flex-wrap gap-3 md:gap-4">
                    {milestone?.metrics?.map((metric, idx) => (
                      <div key={idx} className="flex items-center gap-2">
                        <Icon name={metric?.icon} size={14} color="var(--color-primary)" />
                        <span className="text-xs md:text-sm font-medium text-foreground">
                          {metric?.label}: <span className="text-primary">{metric?.value}</span>
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnershipTimeline;